import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function BookServicesPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const services = [
    { id: 1, name: 'Bathroom Cleaning Basic', category: 'cleaning', price: '₹299', rating: 4.8, icon: 'ri-drop-line', desc: 'Basic bathroom cleaning and sanitization' },
    { id: 2, name: 'Bathroom Cleaning Intense', category: 'cleaning', price: '₹499', rating: 4.9, icon: 'ri-shining-line', desc: 'Deep bathroom cleaning with scrubbing and disinfection' },
    { id: 3, name: 'Dusting', category: 'cleaning', price: '₹199', rating: 4.7, icon: 'ri-brush-2-line', desc: 'Complete dusting of your home surfaces' },
    { id: 4, name: 'Sofa Cleaning', category: 'cleaning', price: '₹399', rating: 4.8, icon: 'ri-home-heart-line', desc: 'Professional sofa and upholstery cleaning' },
    { id: 5, name: 'Carpet Cleaning', category: 'cleaning', price: '₹449', rating: 4.8, icon: 'ri-eraser-line', desc: 'Deep carpet cleaning and stain removal' },
    { id: 6, name: 'Kitchen Utensil Cleaning', category: 'cleaning', price: '₹249', rating: 4.7, icon: 'ri-knife-line', desc: 'Thorough cleaning of kitchen utensils and cookware' },
    { id: 7, name: 'Fan Cleaning', category: 'cleaning', price: '₹149', rating: 4.6, icon: 'ri-windy-line', desc: 'Cleaning and dusting of ceiling and table fans' },
    { id: 8, name: 'Window Cleaning', category: 'cleaning', price: '₹299', rating: 4.7, icon: 'ri-window-line', desc: 'Streak-free window and glass cleaning' },
    { id: 9, name: 'Cooking', category: 'cooking', price: '₹350/hr', rating: 4.9, icon: 'ri-restaurant-line', desc: 'Personal chef services at your home' },
    { id: 10, name: 'Water Filter', category: 'maintenance', price: '₹199', rating: 4.6, icon: 'ri-filter-3-line', desc: 'Water filter servicing and maintenance' },
  ];

  const categories = [
    { id: 'all', name: 'All Services', icon: 'ri-grid-line' },
    { id: 'cleaning', name: 'Cleaning', icon: 'ri-brush-2-line' },
    { id: 'cooking', name: 'Cooking', icon: 'ri-restaurant-line' },
    { id: 'maintenance', name: 'Maintenance', icon: 'ri-tools-line' },
  ];

  const filteredServices = services.filter(service => {
    const matchesCategory = selectedCategory === 'all' || service.category === selectedCategory;
    const matchesSearch = service.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      service.desc.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-r from-purple-600 to-purple-700 text-white relative overflow-hidden"
        style={{
          backgroundImage: "url('https://readdy.ai/api/search-image?query=modern%20smartphone%20with%20home%20services%20booking%20app%2C%20purple%20and%20white%20design%2C%20service%20selection%20screen%2C%20professional%20app%20mockup%20with%20booking%20features%2C%20clean%20digital%20interface&width=1200&height=500&seq=book-services-hero&orientation=landscape')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
        <div className="absolute inset-0 bg-purple-600/80"></div>
        <div className="container mx-auto px-6 relative z-10 text-center">
          <h1 className="text-4xl font-bold mb-4">Book Home Services</h1>
          <p className="text-xl max-w-2xl mx-auto">
            Choose from 50+ verified services and get them done at your doorstep
          </p>
        </div>
      </section>

      {/* Search and Filters */}
      <section className="py-8 bg-white shadow-sm">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            {/* Search Bar */}
            <div className="relative mb-8">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <i className="ri-search-line text-gray-400 text-sm"></i>
              </div>
              <input
                type="text"
                placeholder="Search for services..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
              />
            </div>

            {/* Category Filters */}
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${selectedCategory === category.id
                    ? 'bg-purple-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                >
                  <i className={`${category.icon} mr-2`}></i>
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              {selectedCategory === 'all'
                ? 'All Services'
                : categories.find(c => c.id === selectedCategory)?.name}{' '}
              <span className="text-gray-500 font-normal ml-2">
                ({filteredServices.length} services)
              </span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredServices.map((service) => (
              <div
                key={service.id}
                className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100"
              >
                <div className="p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                      <i className={`${service.icon} text-xl text-purple-600`}></i>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold text-gray-800">{service.price}</div>
                      <div className="flex items-center text-sm text-gray-600">
                        <i className="ri-star-fill text-yellow-500 mr-1"></i>
                        {service.rating}
                      </div>
                    </div>
                  </div>

                  <h3 className="text-lg font-semibold text-gray-800 mb-2">{service.name}</h3>
                  <p className="text-gray-600 text-sm mb-4">{service.desc}</p>

                  <button className="w-full bg-purple-600 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap">
                    Book Now
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredServices.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-4xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">No services found</h3>
              <p className="text-gray-500">Try adjusting your search or category filters</p>
            </div>
          )}
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">How It Works</h2>
            <p className="text-xl text-gray-600">Book your service in 3 simple steps</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Choose Service</h3>
              <p className="text-gray-600">Select the service you need from our comprehensive list</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Book & Pay</h3>
              <p className="text-gray-600">Choose your preferred time slot and make secure online payment</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Relax</h3>
              <p className="text-gray-600">Our verified partner arrives at your doorstep to complete the job</p>
            </div>
          </div>
        </div>
      </section>

      {/* Download App CTA */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">
            Get the BNM Customer App
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Download our app for faster booking and exclusive offers
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* Android Button */}
            <a
              href="https://play.google.com/store/apps/details?id=com.baainearme.customerapp"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              <i className="ri-android-line mr-2 text-lg"></i>
              Download for Android
            </a>

            {/* iOS Button */}
            <a
              href="https://apps.apple.com/app/bnm/id6751604989"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-800 text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-900 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              <i className="ri-app-store-line mr-2 text-lg"></i>
              Download for iOS
            </a>
          </div>
        </div>
      </section>


      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <img
                src="https://static.readdy.ai/image/10053dadbce1851b7032d4a2f38526c3/83173065781489fd4e90ffc998d6a3d9.jfif"
                alt="Baainearme"
                className="h-8 mb-4"
              />
              <p className="text-gray-400">Book trusted home services with just a few taps</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">For Customers</h3>
              <ul className="space-y-2 text-gray-400">

                <li>
                  <Link to="/customer-support" className="hover:text-white cursor-pointer">
                    Customer Support
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <Link to="/partner" className="hover:text-white cursor-pointer">
                    Become Partner
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-white cursor-pointer">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/faqs" className="hover:text-white cursor-pointer">
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <Link to="/customer-terms" className="hover:text-white cursor-pointer">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/customer-privacy" className="hover:text-white cursor-pointer">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/refund-policy" className="hover:text-white cursor-pointer">
                    Refund Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
